
import { defineComponent, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { IPartModelWithDepartmentName } from '@/core/interfaces/Models';
import { DonViService } from '@/core/services/DonVi.service';
import { useRouterCustom } from '../../../../core/hooks/use-router-custom';
import { usePageHeader } from '@/core/hooks/usePageHeader';

import BoPhanService from '@/core/services/BoPhan.service';
import PartTable from '@/views/crafted/pages/part/part-table/PartTable.vue';
import PageContentBase from '../../../../layout/_shared/PageContentBase.vue';

export default defineComponent({
  name: 'danh-sach-bo-phan',

  components: { PartTable, PageContentBase },

  setup() {
    const { push } = useRouterCustom();
    const store = useStore();
    const parts = ref<IPartModelWithDepartmentName[]>([]);

    usePageHeader({
      title: 'Danh sách bộ phận',
      breadcrumbs: [{ text: 'Bộ phận' }],
      addLabel: 'Thêm bộ phận',
      onAdd: () => push('/quan-ly/bo-phan/tao-moi'),
    });

    onMounted(async () => {
      const data = await BoPhanService.listForSelect();
      const {
        data: {
          data: { ten_don_vi },
        },
      } = await DonViService.fetchCurrentDepartmentById(
        store.getters.currentUser.departmentId
      );
      parts.value = data.map((item) => ({
        ...item,
        departmentName: ten_don_vi,
      }));
    });

    return {
      parts,
    };
  },
});
